/**
 * Temporary bridge between type-specific `mapX` (extractAndStashReferenceWellsTree)
 * and widget mount. Raw versioned trees are keyed by widget uuid until the host
 * Wrapper consumes them via takePendingReferenceWellsTree.
 */
const pendingTrees = new Map<string, unknown>();

export function stashPendingReferenceWellsTree(uuid: string, raw: unknown): void {
  pendingTrees.set(uuid, raw);
}

export function takePendingReferenceWellsTree(uuid: string): unknown | undefined {
  const value = pendingTrees.get(uuid);
  pendingTrees.delete(uuid);

  return value;
}
